import moment from "moment";
import _ from "lodash";
const salt = 'EncrytData'

export const addAllKeyWordsIntoArrays = (array, key) => {
  if (array.length > 0) {
    let Obj = { ...array[0] };
    Object.keys(Obj).map((x) => {
      Obj[x] = null;
      key ? (Obj[key] = "All") : "";
    });
    return [Obj].concat(array);
  } else return array;
};

export const addAllKeyWordsIntoArrays_2 = (array, key) => {
  if (array.length > 0) {
    let Obj = { ...array[0] };
    Object.keys(Obj).map((x) => {
      Obj[x] = null;
      key ? (Obj[key] = "All") : "";
    });
    return [Obj].concat(array);
  } else return array;
};

export const generateRandomCode = (max) => {
  return Math.floor(
    Math.pow(10, max - 1) +
      Math.random() * (Math.pow(10, max) - Math.pow(10, max - 1) - 1)
  );
  // return Array(max).fill('').reduce((accumulator) => accumulator += Math.floor(Math.random() * (max - 2) + 2), '');
};

export const UniqueRandomNumber = () => {
  let u_number = Math.floor(new Date().valueOf() * Math.random());
  return new String(u_number).substring(0, 8);
};

export const createUniqueReceiptCodeWithDate = (date) => {
  return `${moment(date).format("YYMMDDHHmm")}${Math.floor(
    Math.random() * 8999 + 1000
  )}`;
};

export const randomAlphaNumeric = () => {
  return `${moment().format("YYMMDDHHmm")}${Math.floor(
    Math.random() * 8999 + 1000
  )}`;
};

export const removeDuplicates = (originalArray, prop) => {
  var newArray = [];
  var lookupObject = {};

  for (var i in originalArray) {
    lookupObject[originalArray[i][prop]] = originalArray[i];
  }

  for (i in lookupObject) {
    newArray.push(lookupObject[i]);
  }
  return newArray;
};

export const movieWeekEnd = (date) => {
  const dayINeed = 5;
  let startDate = moment(date);
  let FinalDate = null;
  if (startDate.isoWeekday() === 5) {
    startDate.add(1, "days");
  }
  while (startDate.isoWeekday() !== dayINeed) {
    let d = startDate;
    FinalDate = d.format();
    startDate.add(1, "days");
  }
  return FinalDate;
};

export const getSeatLayoutModified = (
  flatSeats = [],
  screen_seat_type = [],
  oldSeatlayout = []
) => {
  let seatsRowsRaw = [];

  /** get the grid */
  seatsRowsRaw = _(flatSeats)
    .groupBy((item) => String(item.sl_row_num).padStart(4, "0"))
    .sortBy((group) => flatSeats.indexOf(group[0]))
    .value()
    .map((row) => {
      row.forEach((singleSeat) => {
        singleSeat.selectStatus = singleSeat.SelectStatusFlag = false;
      });
      /** sorting by col asc for each row, just in case */
      return row.sort((a, b) => a.sl_col_num - b.sl_col_num);
    });

  let ssts = [];
  let sstsPayload = Array.from(screen_seat_type);
  let ssts_seats = [];
  let seatsRowsRawPrevIndex = 0;
  let seatsRowsRawlength = seatsRowsRaw.length;

  /** get sst seat types from the grid */
  seatsRowsRaw.forEach((row, index) => {
    let sst = sstsPayload.filter((x) => x.sst_id == row[0].sst_id);
    if (ssts.length > 0 && ssts[ssts.length - 1].sst_id != row[0].sst_id) {
      ssts.push(sst[0]);
    }
    if (ssts.length == 0) {
      ssts.push(sst[0]);
    }
    /** get seat slice for sst seat types of the grid */
    const rowNext = seatsRowsRaw[index + 1];
    if (rowNext && row[0].sst_id != rowNext[0].sst_id) {
      ssts_seats.push(getSubarray(seatsRowsRaw, seatsRowsRawPrevIndex, index));
      seatsRowsRawPrevIndex = index + 1;
    }
    if (rowNext == undefined) {
      ssts_seats.push(getSubarray(seatsRowsRaw, seatsRowsRawPrevIndex, index));
      seatsRowsRawPrevIndex = seatsRowsRawlength;
    }
  });

  if (ssts.length !== ssts_seats.length) {
    //   throw new Error('something went wrong with the seats array, ssts, ssts_seats doesnt match')
    return oldSeatlayout;
  }

  /** zip seat slice into sst seat types of the grid */
  return _.zipWith(ssts, ssts_seats, function (types, seats) {
    return {
      ...types,
      seatType: types.sst_seat_type,
      seat_net_price: seats.flatMap((x) => x)[0].seat_net_price || "",
      seat_price: seats.flatMap((x) => x)[0].seat_price || "",
      seats: seats.flatMap((x) => x),
      seatsFinal: seats.map((x) => x),
      debug: seats
        .flatMap((x) => x)
        .map((x) => x.sl_seat_name)
        .join(","),
    };
  });
};

const getSubarray = (array = [], fromIndex = 0, toIndex = 0) => {
  let a = array;
  return a.slice(fromIndex, toIndex + 1);
};


export const encryptString = (text) => {
 // console.log('text', text);
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);

  return text
    .split("")
    .map(textToChars)
    .map(applySaltToChar)
    .map(byteHex)
    .join("");
};

export const decryptString = (encoded) => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded
    .match(/.{1,2}/g)
    .map((hex) => parseInt(hex, 16))
    .map(applySaltToChar)
    .map((charCode) => String.fromCharCode(charCode))
    .join("");
};


export const getOMAErrorCode = (errorCode = '') => {
  let errorMsg = ``;
  if(errorCode) {
    switch (errorCode) {
      case "E000":
        errorMsg = `TRANSACTION SUCCESS`;
        break;
      case "E001":
        errorMsg = `Terminal Not Initialized`;
        break;
      case "E002":
        errorMsg = `Batch Full`;
        break;
      case "E003":
        errorMsg = `Card Not removed from Card Reader`;
        break;
      case "E004":
        errorMsg = `Incorrect Amount Received`;
        break;
      case "E005":
        errorMsg = `Invalid Message Type Received`;
        break;
      case "E006":
        errorMsg = `No Paper Roll`;
        break;
      case "E007":
        errorMsg = `XML Format Error`;
        break;
      case "E008":
        errorMsg = `Expired Card`;
        break;
      case "E009":
        errorMsg = `Card Not Supported`;
        break;
      case "E010":
        errorMsg = `Transaction Not Permitted`;
        break;
      case "E011":
        errorMsg = `Low Battery (In IWL Terminal only)`;
        break;
      case "E012":
        errorMsg = `Data Base Error Exception`;
        break;
      case "E013":
        errorMsg = `Invalid Track`;
        break;
      case "E014":
        errorMsg = `Customer Cancellation`;
        break;
      case "E015":
        errorMsg = `Card Reader TimeOut`;
        break;
      case "E016":
        errorMsg = `Pin Time Out`;
        break;
      case "E017":
        errorMsg = `Invalid Expiry`;
        break;
      case "E018":
        errorMsg = `Card not supported (Bin Not found)`;
        break;
      case "E019":
        errorMsg = `AID Not Supported`;
        break;
      case "E020":
        errorMsg = `Wrong Password (Need to check)`;
        break;
      case "E021":
        errorMsg = `Chip Read Error`;
        break;
      case "E022":
        errorMsg = `Service Code Check Error`;
        break;
      case "E023":
        errorMsg = `Connection Error`;
        break;
      case "E024":
        errorMsg = `Send Exception`;
        break;
      case "E025":
        errorMsg = `Receive Exception`;
        break;
      case "E026":
        errorMsg = `Invalid Receipt Number`;
        break;
      case "E027":
        errorMsg = `Transaction already voided`;
        break;
      case "E028":
        errorMsg = `Transaction not found`;
        break;
      case "E029":
        errorMsg = `Wrong N Digits`;
        break;
      case "E030":
        errorMsg = `Maximum Amount Digits Exceeded`;
        break;
      case "E031":
        errorMsg = `ATM Only Exception`;
        break;
      case "E032":
        errorMsg = `Amount Not Matching`;
        break;
      case "E033":
        errorMsg = `Disk Exception (Remote Program Download)`;
        break;
      case "E034":
        errorMsg = `Decompression Exception`;
        break;
      case "E035":
        errorMsg = `Reversal Incomplete`;
        break;
      case "E036":
        errorMsg = `Card Removed during Transaction`;
        break;
      case "E037":
        errorMsg = `Response parse Error`;
        break;
      case "E038":
        errorMsg = `Reversal Send Exception`;
        break;
      case "E039":
        errorMsg = `Reversal Receive Exception`;
        break;
      case "E040":
        errorMsg = `Crypto Error`;
        break;
      case "E041":
        errorMsg = `Batch Empty`;
        break;
      case "E042":
        errorMsg = `Swipe Card Only`;
        break;
      case "E043":
        errorMsg = `Runtime Exception`;
        break;
      case "E044":
        errorMsg = `Contactless Read Exception`;
        break;
      case "E045":
        errorMsg = `Sending Batch In complete`;
        break;
      case "E046":
        errorMsg = `Fall Back Not Supported`;
        break;
      case "E047":
        errorMsg = `Exceed Max Tip Exception`;
        break;
      case "E048":
        errorMsg = `Transaction Time Out Exception`;
        break;
      case "E050":
        errorMsg = `Invalid RRN Exception`;
        break;
      case "E051":
        errorMsg = `Initialize POS Exception`;
        break;
      case "E052":
        errorMsg = `Connection retry exceeded/ Serial Number Mismatch`;
        break;
      case "E053":
        errorMsg = `Batch Delete Exception`;
        break;
      case "E054":
        errorMsg = `Invalid Password`;
        break;
      case "E057":
        errorMsg = `Key Load Exception`;
        break;
      case "E058":
        errorMsg = `CA Key Exception`;
        break;
      case "E059":
        errorMsg = `Mag Stripe Read Exception`;
        break;
      case "E061":
        errorMsg = `GPRS Reboot Required`;
        break;
      case "E062":
        errorMsg = `Param Download Failed`;
        break;
      case "E065":
        errorMsg = `PIN Key KCV Error`;
        break;
      case "E066":
        errorMsg = `PAN Key KCV Error`;
        break;
      default:
        errorMsg = `FAILED`;
        break;
    }
  } 
  return errorMsg;
}


export const getAlhamraErrorCode = (errorCode = '') => {
  let errorMsg = ``;
  let status = false;
  return new Promise((resolve) => {
    if(errorCode) {
      switch (errorCode) {
        case "000":
          errorMsg = `TRANSACTION SUCCESS`;
          status = true;
          break;
        case "001":
          errorMsg = `Approve`;
          status = true;
          break;
        case "003":
          errorMsg = `Approved (VIP)`;
          status = true;
          break;
        case "007":
          errorMsg = `Approved, update ICC`;
          status = true;
          break;
        case "060":
          errorMsg = `Approved in StandIn Processing (STIP) mode by mada switch`;
          status = true;
          break;
        case "061":
          errorMsg = `Approved in Stand-In Processing (STIP) mode by mada POS`;
          status = true;
          break;
        case "087":
          errorMsg = `Offline Approved (Chip only)`;
          status = true;
          break;
        case "089":
          errorMsg = `Unable to go On-line. Off-line approved (Chip only)`;
          status = true;
          break;
        case "100":
          errorMsg = `Do not honour`;
          status = false;
          break;
        case "101":
          errorMsg = `Expired card`;
          status = false;
          break;
        case "102":
          errorMsg = `Suspected fraud (To be used when ARQC validation fails)`;
          status = false;
          break;
        case "103":
          errorMsg = `Card acceptor contact acquirer`;
          status = false;
          break;
        case "104":
          errorMsg = `Restricted card `;
          status = false;
          break;
        case "105":
          errorMsg = `Card acceptor call acquirer's security department`;
          status = false;
          break;
        case "106":
          errorMsg = `Allowable PIN tries exceeded`;
          status = false;
          break;
        case "107":
          errorMsg = `Refer to card issuer`;
          status = false;
          break;
        case "108":
          errorMsg = `Refer to card issuer's special conditions`;
          status = false;
          break;
        case "109":
          errorMsg = `Invalid merchant`;
          status = false;
          break;
        case "110":
          errorMsg = `Invalid amount`;
          status = false;
          break;
        case "111":
          errorMsg = `Invalid card number`;
          status = false;
          break;
        case "112":
          errorMsg = `PIN data required`;
          status = false;
          break;
        case "114":
          errorMsg = `No account of type requested`;
          status = false;
          break;
        case "116":
          errorMsg = `Not sufficient funds`;
          status = false;
          break;
        case "117":
          errorMsg = `Incorrect PIN`;
          status = false;
          break;
        case "121":
          errorMsg = `Exceeds withdrawal amount limit`;
          status = false;
          break;
        case "125":
          errorMsg = `Card not effective`;
          status = false;
          break;
        case "126":
          errorMsg = `Invalid PIN block`;
          status = false;
          break;
        case "188":
          errorMsg = `Offline declined`;
          status = false;
          break;
        case "300":
          errorMsg = `Successful`;
          status = true;
          break;
        case "301":
          errorMsg = `Not supported by receiver`;
          status = false;
          break;
        case "306":
          errorMsg = `Not successful `;
          status = false;
          break;
        case "400":
          errorMsg = `Accepted`;
          status = true;
          break;
        case "500":
          errorMsg = `Approved, Reconciled, in balance`;
          status = true;
          break;
        case "800":
          errorMsg = `Accepted`;
          status = true;
          break;
        case "940":
          errorMsg = `Unknown terminal`;
          status = false;
          break;
        default:
          errorMsg = `TRANSACTION FAILED`;
          status = false;
          break;
      }
    } 
    return resolve({
      message: errorMsg,
      status: status
    })
  })
}


// WEBPACK FOOTER //
// ./src/helper/collection.js